var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.container},[_c('NavBarRoutes',{attrs:{"routes":_vm.persistentNavRoutes}}),(_vm.loggedIn)?_c('NavBarRoutes',{attrs:{"routes":_vm.loggedInNavRoutes}}):_c('NavBarRoutes',{attrs:{"routes":_vm.loggedOutNavRoutes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }